import { rem } from "polished";
import DataTable from "react-data-table-component";
import styled from "styled-components";
import screen from "superior-mq";
import { LoadingContainer } from "~/shared/components/ds/Spinner";
import { formatCommaNumbers } from "~/shared/util/formatText";
import { bp } from "../../styles/helpers";

const customStyles = {
  tableWrapper: {
    style: {
      backgroundColor: "var(--color-ds-surface-foundation)",
    },
  },
  noData: {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "var(--color-ds-text-primary)",
      backgroundColor: "var(--color-ds-surface-foundation)",
    },
  },
  progress: {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "var(--color-ds-text-primary)",
      backgroundColor: "var(--color-ds-surface-foundation)",
    },
  },
  headCells: {
    color: "var(--color-ds-text-primary)",
    activeSortStyle: {
      "&:focus": {
        color: "var(--color-ds-teal-11)",
      },
      "&:hover": {
        color: "var(--color-ds-text-primary)",
      },
    },
    inactiveSortStyle: {
      "&:focus": {
        color: "var(--color-ds-teal-11)",
      },
      "&:hover": {
        color: "var(--color-ds-text-primary)",
      },
    },
  },
};

const StyledTable = styled(DataTable).attrs((props) => ({
  sortServer: true,
  noHeader: props.noHeader === false ? false : true,
  subHeader: false,
  paginationServer: true,
  customStyles: customStyles,
  progressComponent: <LoadingContainer level="component" />,
}))`
  color: var(--color-ds-text-primary);
  margin-bottom: 20px;
  font-size: ${rem(15)};

  .rdt_Table {
    color: var(--color-ds-text-primary);
    background-color: var(--color-ds-surface-foundation);
  }

  .rdt_TableCol {
    font-size: inherit;
    font-weight: 600;
    padding-right: 12px;
    padding-left: 12px;
    color: var(--color-ds-text-primary);
    background-color: var(--color-ds-surface-foundation);
  }

  .rdt_TableHead {
    font-size: ${rem(14)};
    color: var(--color-ds-text-primary);
    background-color: var(--color-ds-surface-foundation);

    ${(props) =>
      !props.showMobileHeader &&
      screen.below(
        bp.portrait,
        `
        display: none;
      `,
      )}
  }

  .rdt_TableHeadRow {
    border-color: var(--color-ds-stroke-secondary);
    color: var(--color-ds-text-primary);
    background-color: var(--color-ds-surface-foundation);
  }

  .rdt_TableRow {
    padding: ${(props) => (props.small ? "15px 0" : "24px 0")};
    border: 0;
    font-size: inherit;
    border-radius: var(--border-radius);
    color: var(--color-ds-text-primary);
    background-color: var(--color-ds-surface-foundation);

    &:nth-of-type(even) {
      background-color: var(--off-white);
    }

    ${screen.below(
      bp.portrait,
      `
      display: block;
      margin-bottom: 32px;
      border-bottom: solid 2px var(--color-ds-stroke-primary);
      border-top: solid 2px var(--color-ds-stroke-primary);
      background: var(--offwhite);
      border-radius: 0;
      padding: 0;

      &:last-child {
        margin-bottom: 0;
      }
    `,
    )}

    ${(props) =>
      props.showMobileHeader &&
      screen.below(
        bp.portrait,
        `
        display: flex;
      `,
      )}
  }

  .rdt_TableCell {
    padding-right: 12px;
    padding-left: 12px;
    align-items: ${(props) => (props.cellAlign ? props.cellAlign : "center")};

    ${screen.below(
      bp.portrait,
      `
      justify-content: space-between;
      max-width: unset;
      border-bottom: solid 1px var(--color-ds-stroke-primary);
      align-items: center;
    `,
    )}

    ${(props) =>
      props.showMobileHeader &&
      screen.below(
        bp.portrait,
        `
      align-items: flex-start;
      `,
      )}
  }
`;

const ResultsHeader = styled.header`
  padding: 10px 0;
  font-size: ${rem(15)};

  ${screen.below(
    bp.portrait,
    `
      margin-bottom: 10px;
    `,
  )}
`;

const Table = (props) => {
  return (
    <>
      {props.paginationTotalRows ? (
        <ResultsHeader>
          {formatCommaNumbers(props.paginationTotalRows)}
          &nbsp;result{props.paginationTotalRows > 1 ? "s" : null}
        </ResultsHeader>
      ) : null}
      <StyledTable {...props} />
    </>
  );
};

Table.dashTableStyles = {
  fontSize: ".875rem",
  padding: "8px",
  marginBottom: 0,
};
Table.dashPaginationStyles = {
  fontSize: "1rem",
  paddingRight: "8px",
  marginBottom: 0,
};

export default Table;

export { default as DataCell } from "./DataCell";
export { default as ManageCell } from "./ManageCell";
